import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import SMSNotification from "../../components/Notification/sms";

const SMSNotificationPage = (): ReactElement => {
  return (
    <Layout>
      <SMSNotification />
    </Layout>
  );
};

export default SMSNotificationPage;
